<template>
    <footer class="pp-footer" :class="{'pp-footer--fixed': fixed, 'color': color}">
        <slot></slot>
    </footer>
</template>

<script>
/**
 * 顶部栏
 * @param {boolean} fixed 固定在底部
 * @param {boolean} color 带背景色
 */
export default {
    name: 'pp-footer',
    props: {
        fixed: Boolean,
        color: Boolean,
    },
    created: function() {
        if(this.$parent.$options.name === 'pp-container') {
            this.$parent.hasFooter = true
        }
    },
}
</script>

<style>

</style>
